// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1KG00","assignButton":"CreateEditEquipmentSchedule_assignButton__1PCit"};